import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
@Injectable({
  providedIn: 'root'
})
export class PlatformGuard implements CanActivate {
  constructor(
    private AuthService: AuthService,
    private router: Router,
) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

      if(this.AuthService.platformCheck(route.data.platform)){
        return true;
    }
    this.router.navigate(['/404']);
    return false;
  }
  
}
